import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default function AuthProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  // Check admin status on mount
  useEffect(() => {
    const adminStatus = localStorage.getItem('adminMode') === 'true';
    setIsAdmin(adminStatus);
    setIsAuthenticated(adminStatus);
  }, []);

  const loginAdmin = (password) => {
    // Simple password check for now - will be replaced with proper auth
    // Use hardcoded password for local dev due to env variable issues with special chars
    const ADMIN_PASSWORD = process.env.NODE_ENV === 'production' 
      ? process.env.REACT_APP_ADMIN_PASSWORD 
      : 'ItsJu$tAW4ll!77';
    
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('adminMode', 'true');
      setIsAdmin(true);
      setIsAuthenticated(true);
      return true;
    }
    return false;
  };

  const logoutAdmin = () => {
    localStorage.removeItem('adminMode');
    setIsAdmin(false);
    setIsAuthenticated(false);
  };

  const value = {
    isAdmin,
    isAuthenticated,
    loginAdmin,
    logoutAdmin
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
